import AdSense from "@/components/common/ad-sense";
import {
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_GAM,
  ADS_PROVIDER_PLAYWIRE,
  ADS_PROVIDER_ADSENSE,
} from "@/redux/siteData";
import { useEffect, useState } from "react";

function getAdHeight(): number {
  const viewport =
    window.visualViewport?.height ??
    document.documentElement.clientHeight ??
    window.innerHeight;

  const h = Math.min(viewport, window.innerHeight);

  if (h <= 599) return 50;
  if (h <= 699) return 70;
  return 100;
}

let GAM_ID_MOBILE = "div-ch_game_mobile_bottom";

export default function StickyAd({ adsProvider }: { adsProvider: string }) {
  const [height, setHeight] = useState<number>(100);

  useEffect(() => {
    const update = () => setHeight(getAdHeight());

    // Safely add listeners (ios Safari)
    const vv = window.visualViewport;
    vv?.addEventListener("resize", update);
    vv?.addEventListener("scroll", update); // needed for Safari UI collapse

    window.addEventListener("orientationchange", update, { passive: true });
    window.addEventListener("resize", update);

    update(); // set initial correctly

    return () => {
      vv?.removeEventListener("resize", update);
      vv?.removeEventListener("scroll", update);

      window.removeEventListener("orientationchange", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <>
      {/* Spacer to push content above the ad */}
      <div className="flex-shrink-0" style={{ height }} />

      <div
        className="flex fixed bottom-0 left-0 z-30 justify-center items-center w-full shadow-lg"
        style={{
          height,
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
      >
        {/* <div
          id={
            adsProvider === ADS_PROVIDER_YANDEX
              ? "yandex_rtb_R-A-1674804-3"
              : adsProvider === ADS_PROVIDER_GAM
              ? GAM_ID_MOBILE
              : "game_sticky_bottom_mobile"
          }
          className="flex overflow-hidden justify-center items-center w-full h-full"
        /> */}
        {renderAd(adsProvider)}
      </div>
    </>
  );
}

function renderAd(adsProvider: string) {
  switch (adsProvider) {
    case ADS_PROVIDER_PLAYWIRE:
      return (
        <div
          id="game_sticky_bottom_mobile"
          className="flex overflow-hidden justify-center items-center w-full h-full"
        />
      );
    case ADS_PROVIDER_YANDEX:
      return (
        <div
          id="yandex_rtb_R-A-1674804-3"
          className="flex overflow-hidden justify-center items-center w-full h-full"
        />
      );
    case ADS_PROVIDER_GAM:
      return (
        <div
          id={GAM_ID_MOBILE}
          className="flex overflow-hidden justify-center items-center w-full h-full"
        />
      );
    case ADS_PROVIDER_ADSENSE:
      return (
        <AdSense
          adStyles="flex overflow-hidden justify-center items-center w-full h-full"
          showRemoveAds={false}
          slot="7152821243"
          format="auto"
          insStyle={{ width: "100%" }}
        />
      );
  }
}
